@switch (variant()) {
  @case ('sidebar') {
    <div
      class="plan-widget"
      (click)="onClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="onClick()"
      (keydown.space)="onClick(); $event.preventDefault()"
    >
      <div class="plan-widget-header">
        <mat-icon class="plan-widget-icon">pause_circle</mat-icon>
        <span class="plan-widget-label">{{ message() }}</span>
      </div>
      <div class="plan-widget-cta-wrapper">
        <span class="plan-widget-cta">{{ actionText() }}</span>
      </div>
    </div>
  }
  @case ('inline') {
    <div class="inline-banner">
      <mat-icon class="inline-banner-icon">warning</mat-icon>
      <span class="inline-banner-text">{{ message() }}</span>
      @if (showAction()) {
        <app-button
          type="secondary"
          size="small"
          borderRadius="6px"
          (clicked)="onClick()"
          class="inline-banner-action"
        >
          {{ actionText() }}
        </app-button>
      }
    </div>
  }
}
